// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---izM9X","changedRecordsList":"changedRecordsList---k95vU","changedRecord":"changedRecord---_inGm"};